import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ActionIcon, Group, ScrollArea, Text } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { VersionList } from "./VersionList.js";
import { useCaptureEvent } from "../../components/StyleEditorContext.js";
import { Event } from "../../constants/events.js";
import { PrimaryPanel } from "../../components/SidePanel.js";
export const VersionsView = ({ onViewChange }) => {
    const captureEvent = useCaptureEvent();
    const onClose = useCallback(() => {
        captureEvent(Event.CloseVersionsPanel);
        onViewChange("ai");
    }, [captureEvent, onViewChange]);
    return (_jsxs(PrimaryPanel, { width: "640px", children: [_jsxs(Group, { justify: "space-between", align: "center", children: [_jsx(Text, { fw: 600, fz: 16, children: _jsx(FormattedMessage, { id: "heading.versions", defaultMessage: "Versions" }) }), _jsx(ActionIcon, { variant: "subtle", color: "gray", size: 32, onClick: onClose, children: _jsx(IconX, { size: 20, stroke: 1.5 }) })] }), _jsx(ScrollArea, { flex: "1", mih: 0, children: _jsx(VersionList, {}) })] }));
};
